import EditName from './edit_description'
import { reduxForm } from 'redux-form'
import { DESCRIPTION_LENGTH } from 'shared/lengths'
import formUtils from 'lib/form_utils'
import { length } from 'lib/validators'
import { getI18n } from 'client/i18n'
import { updateRemotely } from 'redux/modules/campaign'
import { getCampaignSelector } from 'redux/selectors/campaign'

const i18n = getI18n('components/edit_glimpse/edit_description')

const mapStateToProps = (state, props) => {
  const campaign = getCampaignSelector(state, props)
  return {
    initialValues: {
      description: campaign.description,
    },
  }
}

const mapDispatchToProps = (dispatch, { campaignId }) => {
  return {
    onSave(formValues) {
      return dispatch(
        updateRemotely(campaignId, { description: formValues.description })
      )
    },
  }
}

export default reduxForm(
  {
    form: 'edit_description',
    fields: ['description'],
    validate: length(
      'description',
      DESCRIPTION_LENGTH,
      i18n('description_too_long', {
        maxLength: DESCRIPTION_LENGTH,
      })
    ),
    touchOnChange: true,
  },
  mapStateToProps,
  mapDispatchToProps
)(formUtils(EditName))
